import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import QRCode from 'qrcode';

import { Paper, Grid, Typography, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Chip, Menu, MenuItem} from '@material-ui/core';
import Modal from 'components/Modal';
import Loader from 'components/Loader';
import MTable from 'components/MTable';
import TableMobile from 'components/TableMobile';
import Button from 'components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faQrcode, faBarcode, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

import { fetchSuperLogicaInvoices, removeSuperLogicaDebitWarning, generateToken } from '../../../components/Filter/store/services';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';
import { convertToReal } from 'helpers/converters';

import { useStyles } from './styles';

const clientAreaUserData = require('../../../assets/img/client-area-user-data.svg');
const clientAreaPaymentMethods = require('../../../assets/img/client-area-payment-methods.svg');
const clientAreaBillingHistory = require('../../../assets/img/client-area-billing-history.svg');
const clientAreaProvisionalReceipt = require('../../../assets/img/client-area-provisional-receipt.svg');
const clientAreaUserPreferences = require('../../../assets/img/client-area-user-preferences.svg');
const clientAreaNoClientImage = require('../../../assets/img/client-area-no-client-image.svg');

const noInvoiceHeaders = [
  { title: 'Status', field: 'status', sortable: false },
  { title: 'Empresa', field: 'name', sortable: false },
  { title: 'CNPJ', field: 'documentId', sortable: false },
  { title: 'Vencimento', field: 'dueDate' },
  { title: 'Valor', field: 'amount' }
];

const headers = [
  { title: 'Status', field: 'status', sortable: false },
  { title: 'Empresa', field: 'name', sortable: false },
  { title: 'CNPJ', field: 'documentId', sortable: false },
  { title: 'Vencimento', field: 'dueDate' },
  { title: 'Valor', field: 'amount' },
  { title: 'Ações' }
];

const maskCNPJ = v => {
  v = v?.replace(/\D/g, '');

  let len = v?.length;

  if (len < 12) {
    v = v
      ?.replace(/(\d{3})(\d)/, '$1.$2')
      ?.replace(/(\d{3})(\d)/, '$1.$2')
      ?.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    v = v
      ?.replace(/^(\d{2})(\d)/, '$1.$2')
      ?.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      ?.replace(/\.(\d{3})(\d)/, '.$1/$2')
      ?.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return v?.substring(0, 18);
}

const ClientButton = ({ title, icon, onClick }) => {
  return(
    <button
      style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, backgroundColor: '#FFFFFF', border: '1px solid #D7D7D7', borderRadius: 5, padding: 10, cursor: 'pointer' }}
      onClick={onClick}
    >
      <img src={icon} />
      <Typography color='primary' variant='body1'>
        <b>{title}</b>
      </Typography>
    </button>
  );
}

export default function ListClients() {
  const classes = useStyles();

  const history = useHistory();

  const { width } = useWindowDimensions();
  const isMobile = width < 960;

  const isResale = !!process.env.REACT_APP_RESALE_ID;

  const [superLogica, setSuperLogica] = useState([]);
  const [superLogicaInvoices, setSuperLogicaInvoices] = useState([]);
  const [superLogicaUser, setSuperLogicaUser] = useState({ superlogicaId: '', email: '' });
  const [isClientMessageVisible, setIsClientMessageVisible] = useState(false);

  const [mainUser, setMainUser] = useState({ mainUserId: '', mainUserToken: '' });
  const [pixPaymentModalData, setPixPaymentModalData] = useState({});
  const [isPixPaymentModalOpen, setIsPixPaymentModalOpen] = useState(false);
  const [isRemoveDebitWarningModalOpen, setIsRemoveDebitWarningModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(true);

  const { token } = useSelector(state => state.login);
  const { userId, resaleId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { profileId } = useSelector(state => state.profile.submit);
  const situationEstablishments = useSelector(state => state.login.situation.establishments);

  const noAccessCodeToken = history.location.state?.data?.token || '';

  const isUserAdmin = +profileId == 1;
  const isDebitWarning = situationEstablishments?.some(establishment => +establishment?.debitWarning == 1);

  const [loading, setLoading] = useState(false);

  const [anchor, setAnchor] = useState(null);
  const isAnchorOpen = !!anchor;

  const handleMenuOpen = event => {
    setAnchor(event?.currentTarget);
  }

  const handleMenuClose = () => {
    setAnchor(null);
  }

  const renderStatus = status => {
    if(+status == 1) {
      return(
        <Chip
          label='Em dia'
          style={{ height: 20, color: '#43A047', backgroundColor: 'rgba(67, 160, 71, 0.24)' }}
        />
      );
    }

    return(
      <Chip
        label='Atrasado'
        style={{ height: 20, color: '#F66C6B', backgroundColor: 'rgba(246, 108, 107, 0.34)' }}
      />
    );
  }

  useEffect(() => {
    if(isResale) {
      toast.error('Você não pode acessar esta área.');
      return history.push('/');
    }
  }, [isResale]);

  useEffect(() => {
    (async () => {
      setIsClientMessageVisible(false);

      if(isUserAdmin && !establishmentId) {
        setLoading(false);
        setIsClientMessageVisible(true);
        return toast.error('Selecione um estabelecimento para acessar essa área.');
      }

      setLoading(true);

      const { data } = await fetchSuperLogicaInvoices(isUserAdmin, userId, establishmentId, noAccessCodeToken)
        .finally(() => setLoading(false));

      setMainUser({ mainUserId: data?.mainUserId, mainUserToken: data?.mainUserToken });
      setSuperLogica(data?.clients || []);
      setSuperLogicaInvoices(data?.invoices || []);

      if(data?.clients?.length == 0) {
        setIsClientMessageVisible(true);
      }
    })();
  }, [establishmentId]);

  useEffect(() => {
    if(superLogica?.length > 0) {
      const { superlogicaId, email } = superLogica[0];
      setSuperLogicaUser({ superlogicaId, email });
    }
  }, [superLogica]);

  useEffect(() => {
    if(isPixPaymentModalOpen) {
      getPixQrCode();
    }
  }, [isPixPaymentModalOpen]);

  useEffect(() => {
    if(!!resaleId) {
      return history.push('/visao-geral');
    }
  }, [resaleId]);

  const handleGoToSuperlogica = async url => {
    const { data } = await generateToken(userId, token, superLogicaUser);

    if(!data) {
      return toast.error('Houve um problema ao acessar a área do cliente.');
    }

    return window.open(`${url}?token=${data}`, '_blank').focus();
  }

  const handleAccessPayment = row => {
    setPixPaymentModalData(row);
    setIsPixPaymentModalOpen(true);
  }

  const handlePayInvoice = row => {
    const { invoiceLink } = row;
    return window.open(invoiceLink, '_blank');
  }

  const getPixQrCode = async () => {
    const qrCode = await QRCode.toDataURL(pixPaymentModalData?.pixCode);

    setPixPaymentModalData({
      ...pixPaymentModalData,
      pixQrCode: qrCode
    });
  }

  const removeDebitWarning = () => {
    return removeSuperLogicaDebitWarning(mainUser.mainUserId, mainUser.mainUserToken)
      .then(() => {
        setIsRemoveDebitWarningModalOpen(true);
        setIsPixPaymentModalOpen(false);
      })
      .catch(() => toast.error('Houve um problama ao remover o lembrete de débito.'));
  }

  return(
    <div>
      {(!!history.location.state?.data?.noAccessCode && isPaymentModalOpen) && (
        <Modal
          scroll="body"
          title="Pagamento em atraso"
          open={!!history.location.state?.data?.noAccessCode && isPaymentModalOpen}
          onClose={() => setIsPaymentModalOpen(false)}
        >
          <Typography>Boleto com vencimento atrasado. Por favor pague e envie o comprovante para o financeiro para continuarmos com a parceria.</Typography>
        </Modal>
      )}
      {isRemoveDebitWarningModalOpen && (
        <Modal
          scroll="body"
          title="Lembrete de débito"
          open={isRemoveDebitWarningModalOpen}
          onClose={() => setIsRemoveDebitWarningModalOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Typography variant='h5' color='primary'>Lembrete de débito retirado!</Typography>
            <Typography variant='h6' color='primary' style={{ margin: '20px 0 20px 0' }}>Se não identificarmos o pagamento em até 3 dias úteis, o sistema será desativado.</Typography>
            <Typography variant='h6' color='primary' style={{ margin: '0 0 20px 0' }}>Não se preocupe em enviar o comprovante, o sistema acusa automaticamente o seu pagamento.</Typography>
            <Typography variant='h5' color='primary'>Obrigado pela parceria!</Typography>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: 20 }}>
              <Button
                color='primary'
                onClick={() => setIsRemoveDebitWarningModalOpen(false)}
              >
                Ok, obrigado
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {isPixPaymentModalOpen && (
        <Modal
          scroll="body"
          title="Pagamento"
          open={isPixPaymentModalOpen}
          onClose={() => setIsPixPaymentModalOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ width: '100%', backgroundColor: '#FCFCFC', border: '1px solid #D7D7D7', borderRadius: 5, padding: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography color='primary'>
                  <b>Pague a fatura referente ao CPF/CNPJ</b>
                </Typography>
                <Typography color='textSecondary'>{maskCNPJ(pixPaymentModalData?.documentId)}</Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography color='primary'>
                  <b>Valor</b>
                </Typography>
                <Typography color='textSecondary'>{convertToReal(pixPaymentModalData?.amount)}</Typography>
              </div>
            </div>
            <Typography variant='h6' color='primary' style={{ textAlign: 'center', marginTop: 10 }}>
              Leia o QR Code ou copie e cole o código PIX
            </Typography>
            {(!!pixPaymentModalData?.pixCode && !!pixPaymentModalData?.pixQrCode) && (
              <div>
                <img
                  width='300px'
                  height='300px'
                  src={pixPaymentModalData?.pixQrCode}
                />
              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', width: '100%', marginTop: 10 }}>
              <Typography color='textSecondary' style={{ textAlign: 'center', wordBreak: 'break-all' }}>
                {pixPaymentModalData?.pixCode}
              </Typography>
              <Button
                type='button'
                color='primary'
                onClick={() => {
                  navigator.clipboard.writeText(pixPaymentModalData?.pixCode);
                  return toast.success('Código PIX copiado!');
                }}
                startIcon={
                  <FontAwesomeIcon
                    icon={faCopy}
                    color="#FFFFFF"
                    size="lg"
                  />
                }
              >
                Copiar Código
              </Button>
            </div>
            <Typography variant='h6' style={{ textAlign: 'center', marginTop: 10 }}>
              <b>O pagamento demora até 2 dias úteis para ser identificado.</b>
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', gap: 10, marginTop: 10 }}>
              <Button
                type='button'
                variant='outlined'
                color='tertiary'
                onClick={() => setIsPixPaymentModalOpen(false)}
              >
                Cancelar
              </Button>
              {(isDebitWarning || isUserAdmin) && (
                <Button
                  type='button'
                  color='primary'
                  onClick={removeDebitWarning}
                >
                  Já Paguei
                </Button>
              )}
            </div>
          </div>
        </Modal>
      )}
      {isAnchorOpen && (
        <Menu
          id='invoices-menu'
          anchorEl={anchor}
          open={isAnchorOpen}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={() => {
            handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cadastro/index');
            handleMenuClose();
          }}>
            Dados cadastrais
          </MenuItem>
          <MenuItem onClick={() => {
            handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/clientes/formadepagamento');
            handleMenuClose();
          }}>
            Formas de pagamento
          </MenuItem>
          <MenuItem onClick={() => {
            handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/historicocobrancas/index');
            handleMenuClose();
          }}>
            Histórico de cobranças
          </MenuItem>
          <MenuItem onClick={() => {
            handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/notasfiscais/index');
            handleMenuClose();
          }}>
            Notas fiscais
          </MenuItem>
          <MenuItem onClick={() => {
            handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cobranca/index');
            handleMenuClose();
          }}>
            Minhas pendências
          </MenuItem>
        </Menu>
      )}
      <Paper style={{ padding: isMobile ? '10px 0 5px 0' : 0 }}>
        {isClientMessageVisible && (
          <Grid container style={{ padding: 20 }}>
            <Grid container justify={isMobile ? 'flex-start' : 'center'} alignItems='center' xs={12} md={4}>
              <img src={clientAreaNoClientImage} />
            </Grid>
            <Grid container justify={isMobile ? 'flex-start' : 'center'} alignItems='center' xs={12} md={8}>
              <div>
                <Typography color='primary' variant='h5'>
                  Aqui é a sua área!
                </Typography>
                <Typography color='textSecondary' variant='body2' style={{ marginTop: 20, marginBottom: 20 }}>
                  Assim que firmarmos nossa parceria, este será o lugar onde voce verá <br />
                  suas faturas e as respectivas notas fiscais.
                </Typography>
                <Button
                  type='button'
                  variant='outlined'
                  color='tertiary'
                  onClick={() => history.push('/visao-geral')}
                >
                  Retornar ao início
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
        <Loader isLoading={loading}>
          {(superLogica?.length > 0 && superLogicaInvoices?.length == 0) && (
            <>
              {isMobile && (
                <TableMobile
                  loading={loading}
                  data={superLogica?.map(item => {
                    return {
                      ...item,
                      status: {
                        index: 1,
                        label: 'Status',
                        value: (
                          <Typography color='textSecondary' variant='subtitle2'>
                            {renderStatus(item?.status || '')}
                          </Typography>
                        )
                      },
                      name: {
                        index: 2,
                        label: 'Empresa',
                        value: <Typography color='textSecondary' variant='subtitle2'>{item?.name}</Typography>
                      },
                      documentId: {
                        index: 3,
                        label: 'CNPJ',
                        value: (
                          <Typography color='textSecondary' variant='subtitle2'>
                            {maskCNPJ(item?.documentId || '')}
                          </Typography>
                        )
                      },
                      dueDate: {
                        index: 4,
                        label: 'Vencimento',
                        value: <Typography color='textSecondary' variant='subtitle2'>--</Typography>
                      },
                      amount: {
                        index: 5,
                        label: 'Valor',
                        value: <Typography color='textSecondary' variant='subtitle2'>--</Typography>
                      },
                      userData: {
                        advanced: true,
                        index: 6,
                        label: '',
                        value: (
                          <ClientButton
                            title="Dados cadastrais"
                            icon={clientAreaUserData}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cadastro/index')}
                          />
                        )
                      },
                      paymentMethods: {
                        advanced: true,
                        index: 7,
                        label: '',
                        value: (
                          <ClientButton
                            title="Formas de pagamento"
                            icon={clientAreaPaymentMethods}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/clientes/formadepagamento')}
                          />
                        )
                      },
                      billingHistory: {
                        advanced: true,
                        index: 8,
                        label: '',
                        value: (
                          <ClientButton
                            title="Histórico de cobranças"
                            icon={clientAreaBillingHistory}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/historicocobrancas/index')}
                          />
                        )
                      },
                      provisionalReceipt: {
                        advanced: true,
                        index: 9,
                        label: '',
                        value: (
                          <ClientButton
                            title="Notas fiscais"
                            icon={clientAreaProvisionalReceipt}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/notasfiscais/index')}
                          />
                        )
                      },
                      userPreferences: {
                        advanced: true,
                        index: 10,
                        label: '',
                        value: (
                          <ClientButton
                            title="Minhas pendências"
                            icon={clientAreaUserPreferences}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cobranca/index')}
                          />
                        )
                      }
                    }
                  })}
                />
              )}
              {!isMobile && (
                <MTable
                  loading={loading}
                  headers={noInvoiceHeaders}
                  data={superLogica?.map(item => {
                    return {
                      ...item,
                      documentId: maskCNPJ(item?.documentId),
                      status: renderStatus(item?.status),
                      dueDate: '--',
                      amount: '--'
                    }
                  })}
                  actions={[
                    {
                      icon: () => (
                        <FontAwesomeIcon
                          icon={faEllipsisVertical}
                          color="#022A5C"
                          size="md"
                        />
                      ),
                      onClick: handleMenuOpen
                    }
                  ]}
                />
              )}
            </>
          )}
          {(superLogicaInvoices?.length > 0) && (
            <>
              {isMobile && (
                <TableMobile
                  loading={loading}
                  data={superLogicaInvoices?.map(item => {
                    return {
                      ...item,
                      name: {
                        index: 1,
                        label: 'Empresa',
                        value: (
                          <Typography color='textSecondary' variant='subtitle2'>
                            {superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.name || ''}
                          </Typography>
                        )
                      },
                      documentId: {
                        index: 2,
                        label: 'CNPJ',
                        value: (
                          <Typography color='textSecondary' variant='subtitle2'>
                            {maskCNPJ(superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.documentId || '')}
                          </Typography>
                        )
                      },
                      dueDate: {
                        index: 3,
                        label: 'Vencimento',
                        value: <Typography color='textSecondary' variant='subtitle2'>{moment(item?.dueDate).format('DD/MM/YYYY')}</Typography>
                      },
                      status: {
                        index: 4,
                        label: 'Status',
                        value: (
                          <Typography color='textSecondary' variant='subtitle2'>
                            {renderStatus(superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.status || '')}
                          </Typography>
                        )
                      },
                      amount: {
                        index: 5,
                        label: 'Valor',
                        value: <Typography color='textSecondary' variant='subtitle2'>{convertToReal(item?.amount)}</Typography>
                      },
                      payment: {
                        index: 6,
                        label: 'Pagar',
                        value: (
                          <div style={{ display: 'flex', gap: 10 }}>
                            {!!item?.pixCode && (
                              <IconButton size='small' onClick={() => handleAccessPayment({ ...item })}>
                                <FontAwesomeIcon
                                  icon={faQrcode}
                                  color="#13BC4B"
                                  size="md"
                                />
                              </IconButton>
                            )}
                            <IconButton size='small' onClick={() => handlePayInvoice(item)}>
                              <FontAwesomeIcon
                                icon={faBarcode}
                                color="#13BC4B"
                                size="md"
                              />
                            </IconButton>
                          </div>
                        )
                      },
                      userData: {
                        advanced: true,
                        index: 7,
                        label: '',
                        value: (
                          <ClientButton
                            title="Dados cadastrais"
                            icon={clientAreaUserData}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cadastro/index')}
                          />
                        )
                      },
                      paymentMethods: {
                        advanced: true,
                        index: 8,
                        label: '',
                        value: (
                          <ClientButton
                            title="Formas de pagamento"
                            icon={clientAreaPaymentMethods}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/clientes/formadepagamento')}
                          />
                        )
                      },
                      billingHistory: {
                        advanced: true,
                        index: 9,
                        label: '',
                        value: (
                          <ClientButton
                            title="Histórico de cobranças"
                            icon={clientAreaBillingHistory}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/historicocobrancas/index')}
                          />
                        )
                      },
                      provisionalReceipt: {
                        advanced: true,
                        index: 10,
                        label: '',
                        value: (
                          <ClientButton
                            title="Notas fiscais"
                            icon={clientAreaProvisionalReceipt}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/notasfiscais/index')}
                          />
                        )
                      },
                      userPreferences: {
                        advanced: true,
                        index: 11,
                        label: '',
                        value: (
                          <ClientButton
                            title="Minhas pendências"
                            icon={clientAreaUserPreferences}
                            onClick={() => handleGoToSuperlogica('https://jumptecnologia.superlogica.net/clients/areadocliente/cobranca/index')}
                          />
                        )
                      }
                    }
                  })}
                />
              )}
              {!isMobile && (
                <div className={classes.table}>
                  <Table>
                    <TableHead className={classes.tableHead}>
                      <TableRow>
                        {headers?.map(item => {
                          return <TableCell className={classes.tableHeadText}>{item?.title}</TableCell>
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <Loader isLoading={loading}>
                        {superLogicaInvoices?.length > 0 && superLogicaInvoices?.map(item => {
                          return(
                            <TableRow>
                              <TableCell className={classes.tableRowText}>
                                {renderStatus(superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.status || '')}
                              </TableCell>
                              <TableCell className={classes.tableRowText}>
                                {superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.name || ''}
                              </TableCell>
                              <TableCell className={classes.tableRowText}>
                                {maskCNPJ(superLogica?.find(client => +client?.superlogicaId == +item?.superlogicaId)?.documentId || '')}
                              </TableCell>
                              <TableCell className={classes.tableRowText}>
                                {moment(item?.dueDate).format('DD/MM/YYYY')}
                              </TableCell>
                              <TableCell className={classes.tableRowText}>
                                {convertToReal(item?.amount)}
                              </TableCell>
                              <TableCell className={classes.tableRowText}>
                                <div style={{ display: 'flex', gap: 10 }}>
                                  {!!item?.pixCode && (
                                    <IconButton size='small' onClick={() => handleAccessPayment({ ...item })}>
                                      <FontAwesomeIcon
                                        icon={faQrcode}
                                        color="#022A5C"
                                        size="md"
                                      />
                                    </IconButton>
                                  )}
                                  <IconButton size='small' onClick={() => handlePayInvoice(item)}>
                                    <FontAwesomeIcon
                                      icon={faBarcode}
                                      color="#022A5C"
                                      size="md"
                                    />
                                  </IconButton>
                                  <>
                                    <IconButton size='small' onClick={handleMenuOpen}>
                                      <FontAwesomeIcon
                                        icon={faEllipsisVertical}
                                        color="#022A5C"
                                        size="md"
                                      />
                                    </IconButton>
                                  </>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </Loader>
                    </TableBody>
                  </Table>
                </div>
              )}
            </>
          )}
        </Loader>
      </Paper>
    </div>
  );
}